import { SupporterList } from '@/types';
import { DomainCode } from '@australiangreens/ag-internal-components';
import { AGTypeError } from '@/errors/AGTypeError';
import { ExtendedSearchTreeNode } from '@/types/searchTreeTypes';
import { logger, objectHasAll } from '@/util';
import callBackendApi from '@/apis/call';

const REQUIRED_LIST_FIELDS = ['name', 'qFilter', 'domainCode'];

export const createList = async (token: string, values: Record<string, unknown>) => {
  logger.debug('createList() called', values);

  const hasAllRequired = objectHasAll(values, REQUIRED_LIST_FIELDS);
  if (!hasAllRequired)
    throw new AGTypeError(
      'Missing one or more required fields (must all be set, but can be blank/empty)'
    );

  const data: SupporterList = await callBackendApi({
    token,
    method: 'post',
    endpoint: '/lists',
    data: values,
  });
  return data;
};

export const createListAdv = async (
  token: string,
  values: {
    name: string;
    tree: ExtendedSearchTreeNode;
    domainCode: DomainCode;
    contactIds?: number[];
    campaignId: number | null;
  },
  printTime: boolean | undefined = undefined,
  useAdvancedSearchII: boolean | undefined = undefined
) => {
  logger.debug('createListAdv() called', values);
  if (printTime !== undefined) {
    values.tree.printTime = printTime;
  }
  if (useAdvancedSearchII !== undefined) {
    values.tree.useAdvancedSearchII = useAdvancedSearchII;
  }
  logger.info('Starting creation of list');
  const t0 = performance.now();
  const data: SupporterList = await callBackendApi({
    token,
    method: 'post',
    endpoint: '/lists/adv',
    data: values,
  });
  const timeMs = performance.now() - t0;
  logger.info(`Finished creation of list [${Math.round(timeMs)}ms]`);
  return data;
};
